<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    top
  >
    <!-- eslint-disable -->
    <div v-if="snackbar.html" v-html="snackbar.html"></div>
    <!-- eslint-enable -->
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        id="global-snackbar"
        primary
        text
        v-bind="attrs"
        @click="snackbar.show = false"
        >Close</v-btn
      >
    </template>
  </v-snackbar>
</template>
<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("ui");

export default {
  created() {
    this.$log.debug();
  },
  setup() {
    const { snackbar } = useState(["snackbar"]);
    return {
      snackbar,
    };
  },
};
</script>
